import LittleBurger from "./LittleBurger";

export default LittleBurger;
